"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_financialData = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const dbNodes_1 = require("../../../dbNodes/dbNodes");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils = __importStar(require("../../utils"));
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Financial Data`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            creditFacilitySlug: null,
            financialDataValueMap: {
                financialStatementType: 'incomeStatement',
                reportFrequency: 'month',
                sectionFieldMap: {
                    sanitizedColumnName: '* PLACEHOLDER *',
                    fields: [],
                },
                externalSubSectionSanitizedColumnNames: [],
                externalKeySanitizedColumnName: '* PLACEHOLDER *',
                externalValueSanitizedColumnName: '* PLACEHOLDER *',
                currency: finley_types_1.Bank.Currency.USD,
            },
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = utils.updateArtifactSlug(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
/**
 * Validate the configuration for the node. This checks shape as well logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * If there is an error it should return an array of error messages.
 * If there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const errors = [];
    const allowedInputNodes = ['file_intermediateTape'];
    const edgeErrors = utils.checkEdges({
        node,
        graph,
        isAllowedInputNode: (uiNode) => allowedInputNodes.includes(uiNode.nodeType),
        getUINode,
        minInputs: 1,
        maxInputs: 1,
        minOutputs: 0, // for now, this is terminal node
        maxOutputs: 0, // for now, this is terminal node
    });
    edgeErrors.forEach((err) => errors.push(err));
    return errors;
};
const _isValidFinancialSectionField = (field, statementType) => {
    switch (statementType) {
        case 'balanceSheet':
            return finley_types_1.FinancialData.BalanceSheetSectionTypeIterable.some((section) => field === section);
        case 'incomeStatement':
            return finley_types_1.FinancialData.IncomeStatementSectionTypeIterable.some((section) => field === section);
        default:
            return (0, common_1.finleyAssertUnreachable)(statementType);
    }
};
const validateIntermediateTape = (input) => {
    const { tape, tapeBuilder, graph } = input;
    const { id, artifactSlug, configuration } = tape;
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(dbNodes_1.generatedFinancialData.isNodeConfig(configuration), `validateIntermediateTape: Generated Financial Data tape configuration is not expected structure [artifactSlug:${artifactSlug}]`);
    const configErrors = [];
    const sourceArtifacts = utils.getDirectInputsForArtifact({
        ...graph,
        targetArtifactId: id,
    });
    if (sourceArtifacts.length !== 1) {
        configErrors.push(`Expected single input node for Generated Financial Data, received ${sourceArtifacts.length}`);
        // Return early since no need to even try fetching the tape definition
        // and checking it without having the expected target input node
        return configErrors;
    }
    const inputNode = sourceArtifacts[0];
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(inputNode.id);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, `Generated Financial Data tapeDefinition for ${artifactSlug} is not valid`);
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, `Generated Financial Data tapeDefinition for ${artifactSlug} is null`);
    const { baseFields } = tapeDefinitionResult.data;
    const { financialStatementType, sectionFieldMap, externalSubSectionSanitizedColumnNames, externalKeySanitizedColumnName, externalValueSanitizedColumnName, } = configuration.financialDataValueMap;
    // *** Section Field Map ***
    if (!utils.isValidBaseField({
        targetField: sectionFieldMap.sanitizedColumnName,
        targetTypes: ['string'],
        baseFields,
    })) {
        configErrors.push(`sectionFieldMap column name does not reference valid string baseField [input:${sectionFieldMap.sanitizedColumnName}]`);
    }
    if (sectionFieldMap.fields.length === 0) {
        configErrors.push('sectionFieldMap fields can not be empty');
    }
    // Ensure referenced field aligns with the statement type itself
    for (const { finleyValue } of sectionFieldMap.fields) {
        const isValidField = _isValidFinancialSectionField(finleyValue, financialStatementType);
        if (!isValidField) {
            configErrors.push(`sectionFieldMap references invalid field for statement ${financialStatementType} [field:${finleyValue}]`);
        }
    }
    // *** Sub Section Columns ***
    if (externalSubSectionSanitizedColumnNames) {
        for (const colName of externalSubSectionSanitizedColumnNames) {
            if (!utils.isValidBaseField({
                targetField: colName,
                targetTypes: ['string'],
                baseFields,
            })) {
                configErrors.push(`externalSubSectionSanitizedColumnNames does not reference valid string baseField [input:${colName}]`);
            }
        }
    }
    // *** Key Column ***
    if (!utils.isValidBaseField({
        targetField: externalKeySanitizedColumnName,
        targetTypes: ['string'],
        baseFields,
    })) {
        configErrors.push(`externalKeySanitizedColumnName does not reference valid string baseField [input:${externalKeySanitizedColumnName}]`);
    }
    // *** Value Column ***
    if (!utils.isValidBaseField({
        targetField: externalValueSanitizedColumnName,
        targetTypes: finley_types_1.DataTapeField.NumericTypes,
        baseFields,
    })) {
        configErrors.push(`externalValueSanitizedColumnName does not reference valid baseField [input:${externalValueSanitizedColumnName}]`);
    }
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_financialData = {
    // what should node say on the tape-builder node creation menu.
    nodeTypeText: 'Financial Data',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    // Operation nodes don't render badges
    badgeTexts: ['Generated', 'Financials'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map